import { render, staticRenderFns } from "./ToSDialog.vue?vue&type=template&id=2a900e85"
import script from "./ToSDialog.vue?vue&type=script&lang=js"
export * from "./ToSDialog.vue?vue&type=script&lang=js"
import style0 from "./ToSDialog.vue?vue&type=style&index=0&id=2a900e85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports